export default __webpack_public_path__ + "static/media/science_tools.897f65e1.svg";